import TrashCanIcon from './component'

export default TrashCanIcon
